<template>
  <div class="order-ticket">
    <div class="order-info">
      <div @click="selectOrder()">
        <h1>{{ order.name }}</h1>
        <p>{{ order.delivery_data.address }}</p>
      </div>
      <p class="order-details" @click="viewOrderDetails()">?</p>
    </div>
    <OrderModal :open="showOrderModal" @close="showOrderModal = false" :order="order" @remove="revertOrder" @mark-as-delivered="markAsDelivered" />
  </div>
</template>

<script>
import OrderModal from "./OrderModal.vue";
import { mapGetters } from "vuex";

export default {
  name: "OrderTicket",
  components: {
    OrderModal,
  },
  data() {
    return {
      showOrderModal: false,
    };
  },
  props: {
    order: {
      type: Object,
      required: true,
    },
  },
  emits: ["updateOrders", "filter"],
  methods: {
    selectOrder() {
      if (!this.order.events.selected_at) {
        let currentOrder = this.order;
        currentOrder.events.selected_at = new Date().toISOString();
        currentOrder.delivery_data.status = "assigned";
        this.$emit("filter");
        this.channel.push("delivery:update", currentOrder);
      }
    },
    viewOrderDetails() {
      this.showOrderModal = true;
    },
    markAsDelivered() {
      let currentOrder = this.order;
      currentOrder.events.delivered_at = new Date().toISOString();
      currentOrder.delivery_data.status = "delivered";
      this.channel.push("delivery:update", currentOrder);
    },
    revertOrder() {
      let currentOrder = this.order;
      delete currentOrder.events.selected_at;
      delete currentOrder.delivery_data.status;
      this.channel.push("delivery:update", currentOrder);
      this.$emit("updateOrders");
    },
  },
  computed: {
    ...mapGetters({
      selectedOrders: "selectedOrders",
    }),
  },
};
</script>

<style scoped lang="scss">
.order-ticket {
  padding: 1rem;
  display: flex;
  border-radius: 0.5rem;
  background-color: var(--primary-colour);
  min-width: 80vw;
  max-height: 3rem;

  h1 {
    margin: 0;
    font-size: 1.25rem;
    color: var(--text-colour);
    text-transform: capitalize;
  }

  p {
    margin: 0;
    font-size: 0.95rem;
    color: var(--text-colour);
    opacity: 0.8;
  }

  .order-info {
    width: 100%;
    display: flex;
    justify-content: space-between;

    .order-details {
      color: var(--text-colour);
      font-weight: bold;
      cursor: pointer;
    }
  }
}

@media only screen and (orientation: portrait) {
  .order-ticket {
    width: 40%;
    height: 60%;
  }
}
</style>
